import * as Styled from '../styled'
import BlockedTemporarilySVG from '~components/svgs/BlockedTemporarily'
import { Button } from '~components'
import { useRequest } from 'ahooks'
import { Auth } from '~services'
import { urlHandler } from '~utils/path'
import { Issues } from '../interfaces'
import { useState } from 'react'

function BlockedTemporarily() {
  const url = process.env.REACT_APP_FRETEBRAS_SITE
  const [username, setUserName] = useState('')
  const message = `Olá! Minha conta está bloqueada. Meu CPF é o ${username}. Poderia me ajudar?`
  const { loading, runAsync: logout } = useRequest(Auth.logout, { manual: true })
  useRequest<Issues, []>(Auth.issues, { onSuccess: handleSuccessIssue })

  function handleOpenWhatsapp() {
    window.open(
      `https://api.whatsapp.com/send/?phone=551141181843&text=${encodeURI(
        message,
      )}&app_absent=0`,
      '_blank',
    )
  }

  async function handleLogout() {
    await logout()
    window.open(urlHandler(`${url}/tipo-de-cadastro?q=entrar`), '_self')
  }

  function handleSuccessIssue(data: Issues) {
    if (!data) {
      window.open(`${url}/fretes`, '_self')
      return
    }
    if (data.redirect !== location.pathname) window.open(data.redirect, '_self')
    const username = data.username.replace(/[^\d]/g, '')
    setUserName(username.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4'))
  }

  return (
    <Styled.Wrapper role="region">
      <BlockedTemporarilySVG />

      <Styled.Title>
        Sua conta foi desativada temporariamente
      </Styled.Title>

      <Styled.TermsText>
        Por motivo de segurança, bloqueamos{' '}
        <Styled.HighlightedText>
          temporariamente
        </Styled.HighlightedText>
        {' '}sua conta da Fretebras.
      </Styled.TermsText>

      <Styled.TermsText>
        Para saber mais e pedir o desbloqueio, fale com nossa ouvidoria.
      </Styled.TermsText>

      <Styled.BottomButton  onClick={handleOpenWhatsapp}>
        Falar com ouvidoria
      </Styled.BottomButton>
      <Button color="tertiary" onClick={handleLogout} loading={loading}>
        Sair da conta
      </Button>
    </Styled.Wrapper>
  )
}

export default BlockedTemporarily
